import React from "react";
import "./CMVisionMission.css";
import VisionIcon from "../../assets/Cm-about-vission.png";
import MissionIcon from "../../assets/cm-about-mission.png";

export default function VisionMission() {
  return (
    <section className="vm-wrapper">
      <div className="vm-container1">

        {/* VISION SECTION */}
        <div className="vm-block vm-vision-block">
          <div className="vm-icon-wrap">
            <img src={VisionIcon} alt="Vision Icon" className="vm-icon-cmabout" />
          </div>

          <div className="vm-content">
            <h2 className="vm-title">Vision</h2>
            <div className="vm-divider"></div>

            <p className="vm-text">
  To be a leading integrated force in India’s land development and renewable
  energy sectors, delivering sustainable infrastructure that drives long-term
  value, environmental responsibility, and nationwide progress.
</p>

<p className="vm-text">
  We aim to set new benchmarks in reliability, innovation, and large-scale
  project execution—enabling communities, industries, and investors to build a
  cleaner and more empowered future.
</p>
          </div>
        </div>

        {/* MISSION SECTION */}
        <div className="vm-block vm-mission-block">
          <div className="vm-content">
            <h2 className="vm-title">Mission</h2>
            <div className="vm-divider"></div>

            <p className="vm-text">
  To accelerate India’s growth by providing integrated, high-impact solutions
  in strategic land development and clean energy infrastructure.
  We achieve this by:
</p>

<ul className="vm-list">
  <li>
    1. Delivering Value: Identifying and developing critical land assets that
    unlock development, investment, and long-term opportunity.
  </li>
  <li>
    2. Powering Sustainability: Expanding renewable capacity through reliable,
    large-scale solar and energy projects that promote environmental progress.
  </li>
  <li>
    3. Ensuring Excellence: Executing every project with precision, speed, and
    integrity—supported by a strong foundation of expertise and commitment.
  </li>
</ul>
          </div>

          <div className="vm-icon-wrap">
            <img src={MissionIcon} alt="Mission Icon" className="vm-icon-cmabout" />
          </div>
        </div>

      </div>
    </section>
  );
}
